import React, {useState} from 'react'
import { ButtonGroup, Button, Card, CardBody } from 'reactstrap'
import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import moment from "moment"
import {SelectField} from "../../SelectField";
import {chartTypeOptions} from "../../../../config/chartConfigs";
import { FormattedMessage } from 'react-intl';

const DateButtonGroup = (props) => {
  const {isActiveClass, isInactiveClass, dateFilter, productFilter, selectOptions, setType, expandButton, chartType} = props
  const [activeButton, setActiveButton] = useState("7d")
  const [showCalendar, setShowCalendar] = useState(false)
  const [startDate, setStartDate] = useState(new Date(new Date().setDate(new Date().getDate() - 6)));
  const [endDate, setEndDate] = useState(new Date());
  const [activeCalendar, setActiveCalendar] = useState(false);
  const [dateRange, setDateRange] = useState({start: new Date(new Date().setDate(new Date().getDate() - 6)), end: new Date()})

  const onCancel = () => {
    setShowCalendar(false)
    setStartDate(dateRange.start)
    setEndDate(dateRange.end)
  }

  const onDateChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };

  const onProductChange = (product) => {
    productFilter(product.value)
  }

  const onSubmit = () => {
    if (startDate.toDateString() === endDate.toDateString()) {
      setStartDate(dateRange.start)
      setEndDate(dateRange.end)
      setShowCalendar(false)

      return;
    }

    if (startDate) {

      dateFilter({
        "startDate": startDate,
        "endDate": endDate
      })
      setActiveButton("")
      setShowCalendar(false)
      setActiveCalendar(true)
      setDateRange({start: startDate, end: endDate})
    }
  }

  const handleOnClick = (name) => {
    setShowCalendar(false)

    if (activeButton === name) {

      return;
    }
    setActiveButton(name)

    let today = new Date()
    switch(name) {
      case '1d':
        setActiveCalendar(false)
        const yesterday = new Date(new Date().setDate(today.getDate() - 1));
        setStartDate(yesterday)
        setEndDate(today)
        dateFilter({
          "startDate": yesterday,
          "endDate": today
        })
        setDateRange({start: yesterday, end: today})
        break;
      case '7d':
        setActiveCalendar(false)
        const lastWeek = new Date(new Date().setDate(today.getDate() - 6));

        setStartDate(lastWeek)
        setEndDate(today)
        dateFilter({
          "startDate": lastWeek,
          "endDate": today
        })
        setDateRange({start: lastWeek, end: today})
        break;
      case '1m':
        setActiveCalendar(false)
        const lastMonth = new Date(new Date().setMonth(today.getMonth() - 1));

        setStartDate(lastMonth)
        setEndDate(today)
        dateFilter({
          "startDate": lastMonth,
          "endDate": today
        })
        setDateRange({start: lastMonth, end: today})
        break;
      case '3m':
        setActiveCalendar(false)
        const threeMonthsAgo = new Date(new Date().setMonth(today.getMonth() - 2));

        setStartDate(threeMonthsAgo)
        setEndDate(today)
        dateFilter({
          "startDate": threeMonthsAgo,
          "endDate": today
        })
        setDateRange({start: threeMonthsAgo, end: today})
        break;
      case '6m':
        setActiveCalendar(false)
        const sixMonthsAgo = new Date(new Date().setMonth(today.getMonth() - 5));

        setStartDate(sixMonthsAgo)
        setEndDate(today)
        dateFilter({
          "startDate": sixMonthsAgo,
          "endDate": today
        })
        setDateRange({start: sixMonthsAgo, end: today})
        break;
      case '1y':
        setActiveCalendar(false)
        const oneYearAgo = new Date(new Date().setMonth(today.getMonth() - 11));

        setStartDate(oneYearAgo)
        setEndDate(today)
        dateFilter({
          "startDate": oneYearAgo,
          "endDate": today
        })
        setDateRange({start: oneYearAgo, end: today})
        break;
      case 'ytd':
        setActiveCalendar(false)
        const firstDayOfCurrentYear = new Date(new Date().getFullYear(), 0, 1);

        setStartDate(firstDayOfCurrentYear)
        setEndDate(today)
        dateFilter({
          "startDate": firstDayOfCurrentYear,
          "endDate": today
        })
        setDateRange({start: firstDayOfCurrentYear, end: today})
        break;
      default: break;
    }
  }

  const handleOnTypeChange = (type) => {
    if (type) {
      setType(type.value)
    }
  }

  return (
    <>
      <ButtonGroup>
        <Button className={activeButton === "1d" ? isActiveClass : isInactiveClass} onClick={() => handleOnClick("1d")}>1D</Button>
        <Button className={activeButton === "7d" ? isActiveClass : isInactiveClass} onClick={() => handleOnClick("7d")}>7D</Button>
        <Button className={activeButton === "1m" ? isActiveClass : isInactiveClass} onClick={() => handleOnClick("1m")}>1M</Button>
        <Button className={activeButton === "3m" ? isActiveClass : isInactiveClass} onClick={() => handleOnClick("3m")}>3M</Button>
        <Button className={activeButton === "6m" ? isActiveClass : isInactiveClass} onClick={() => handleOnClick("6m")}>6M</Button>
        <Button className={activeButton === "1y" ? isActiveClass : isInactiveClass} onClick={() => handleOnClick("1y")}>1Y</Button>
        <Button className={activeButton === "ytd" ? isActiveClass : isInactiveClass} onClick={() => handleOnClick("ytd")}>YTD</Button>
        <Button className={showCalendar || activeCalendar ? isActiveClass : isInactiveClass}
                onClick={() => {
                  setShowCalendar(prevState => {setShowCalendar(!prevState)})
                  setStartDate(dateRange.start)
                  setEndDate(dateRange.end)
                }}><i className="fa fa-calendar-alt"> </i></Button>
      </ButtonGroup>
      <div className="filter-product">
        <FormattedMessage id="components.pages.reports.allProducts">
          { placeholder =>
              <SelectField
                defaultValue={{ label: placeholder, value: '' }}
                options={selectOptions}
                placeholder={placeholder}
                onChange={(product) => onProductChange(product)}
              />
          }
        </FormattedMessage>
      </div>
      <div className="filter-product">
        <FormattedMessage id="components.pages.reports.chartType">
          { placeholder =>
              <SelectField
                defaultValue={{label: chartType, value: ''}}
                options={chartTypeOptions}
                placeholder={placeholder}
                onChange={(type) => handleOnTypeChange(type)}
              />
          }
        </FormattedMessage>
      </div>
      {expandButton}
      {showCalendar &&
        <div className="date-picker-container">
          <Card className="custom-date-picker-card">
            <DatePicker
              startDate={startDate}
              endDate={endDate}
              onChange={onDateChange}
              maxDate={new Date()}
              selectsRange
              showMonthDropdown
              inline />
            <Card className="secondary-date-picker-content">
              <CardBody>
                <input className="input-date-range" placeholder="Start date" value={startDate ? moment(startDate).format("DD/MM/YYYY") : ""} readOnly/>
                <input className="input-date-range" placeholder="End date" value={endDate ? moment(endDate).format("DD/MM/YYYY") : ""} readOnly/>
                <Button className="btn btn-default btn-secondary-date-range" onClick={onCancel}>Cancel</Button>
                <Button className="btn btn-default btn-secondary-date-range" disabled={!(startDate && endDate)} onClick={onSubmit}>Submit</Button>
              </CardBody>
            </Card>
          </Card>
        </div>
      }
    </>
  )
}

export { DateButtonGroup }

